import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getBookAnalyses, 
  getBookAnalysis,
  clearLocalBookAnalyses,
  clearLocalActiveBookAnalysis 
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  bookAnalysis: { 
    id: '', 
    result: '', 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    bookAnalysis: false 
  }
};

const slice = createSlice({
  name: 'bookAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getBookAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getBookAnalyses.fulfilled, (state, action) => {
        const { book_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...book_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getBookAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getBookAnalysis.pending, (state) => {
        state.loading.bookAnalysis = true;
      })
      .addCase(getBookAnalysis.fulfilled, (state, action) => {
        const { data: { book_analysis }, cable } = action.payload;
        const foundedBookAnalysis = !!_find(state.all.data, (s) => s.id === book_analysis.id);
        const updatedBookAnalysis = { ...state.bookAnalysis, ...book_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedBookAnalysis ? _map(state.all.data, (e) => e.id === book_analysis.id ? { ...e, ...book_analysis } : e) : [...[book_analysis], ...oldAllData]; 
        const pagination = foundedBookAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.bookAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedBookAnalysis && !cable) state.bookAnalysis = updatedBookAnalysis;       
      })
      .addCase(getBookAnalysis.rejected, (state) => {
        state.loading.bookAnalysis = false;
      })
      .addCase(clearLocalBookAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveBookAnalysis, state => {
        state.bookAnalysis = initialState.bookAnalysis;
      })
  }
})

export default slice.reducer;